

// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
//   Autocomplete, MenuItem,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import axios from 'axios';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../../config';
// import api from '../../../api/axiosInterceptor';

// // Converts DD-MM-YYYY or DD/MM/YYYY to ISO (YYYY-MM-DD)
// const convertDisplayDateToISO = (dateStr) => {
//   if (!dateStr) return '';
//   const parts = dateStr.includes('/') ? dateStr.split('/') : dateStr.split('-');
//   if (parts.length !== 3) return '';
//   const [day, month, year] = parts;
//   return `${year}-${month.padStart(2,'0')}-${day.padStart(2,'0')}`;
// };

// export const AdminAssetPropertyDetailsComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [feOptions, setFeOptions] = useState([]);
//   const [feLoading, setFeLoading] = useState(true);

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState(null);

//   const [formData, setFormData] = useState({
//     asset3_2_base: null,  // object for FE base (Asset3_2)
//     property_detals: '',
//     survey_no: '',
//     property_type: '',      // dropdown value or specified other
//     property_type_other: '',// for specifying other property type when "Other" selected
//     type_of_asset: '',
//     hobli: '',
//     village: '',
//     taluk: '',
//     district: '',
//     state: '',
//     pincode: '',
//     geo_location: '',
//   });

//   const [formErrors, setFormErrors] = useState({});

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteRecord, setDeleteRecord] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },
//     { id: 'name_of_fe', field: 'name_of_fe', headerName: 'Financial Establishment', width: 250 },
//     { id: 'name_of_ca', field: 'name_of_ca', headerName: 'Competent Authority', width: 200 },
//     { id: 'notification', field: 'notification', headerName: 'Notification', width: 150 },
//     { id: 'date', field: 'date', headerName: 'Date', width: 120 },
//     { id: 'notification_no', field: 'notification_no', headerName: 'Notification No', width: 150 },
//     { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 200 },
//     { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 120 },
//     { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },
//     { id: 'type_of_asset', field: 'type_of_asset', headerName: 'Type of Asset', width: 150 },
//     { id: 'hobli', field: 'hobli', headerName: 'Hobli', width: 120 },
//     { id: 'village', field: 'village', headerName: 'Village', width: 120 },
//     { id: 'taluk', field: 'taluk', headerName: 'Taluk', width: 120 },
//     { id: 'district', field: 'district', headerName: 'District', width: 120 },
//     { id: 'state', field: 'state', headerName: 'State', width: 120 },
//     { id: 'pincode', field: 'pincode', headerName: 'Pincode', width: 100 },
//     { id: 'geo_location', field: 'geo_location', headerName: 'Geo Location', width: 200 },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 120,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchAsset3_2Options();
//     fetchData();
//   }, []);

//   const fetchAsset3_2Options = () => {
//     setFeLoading(true);
//     axios.get(`${API_BASE_URL}/asset-mgmt/asset32/`)
//       .then(res => setFeOptions(res.data))
//       .catch(() => {
//         setSnackbarMessage('Failed to load Asset 3(2) base list.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => setFeLoading(false));
//   };

//   const fetchData = () => {
//     setLoading(true);
//     axios.get(`${API_BASE_URL}/asset-mgmt/asset-property/`)
//       .then(response => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           name_of_fe: item.asset3_2_base?.fe?.name_of_fe || '-',
//           name_of_ca: item.asset3_2_base?.fe?.name_of_ca || '-',
//           notification: item.asset3_2_base?.notification || '-',
//           date: item.asset3_2_base?.date ? new Date(item.asset3_2_base.date).toLocaleDateString('en-GB').replace(/\//g, '-') : '-',
//           notification_no: item.asset3_2_base?.notification_no || '-',
//           property_detals: item.property_detals || '-',
//           survey_no: item.survey_no || '-',
//           property_type: item.property_type || '-',
//           type_of_asset: item.type_of_asset || '-',
//           hobli: item.hobli || '-',
//           village: item.village || '-',
//           taluk: item.taluk || '-',
//           district: item.district || '-',
//           state: item.state || '-',
//           pincode: item.pincode || '-',
//           geo_location: item.geo_location || '-',
//           asset3_2_baseId: item.asset3_2_base?.id || null,
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch(() => {
//         setSnackbarMessage('Failed to load Asset Property Details data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAdd = () => {
//     setIsEditMode(false);
//     setSelectedRecord(null);
//     setFormData({
//       asset3_2_base: null,
//       property_detals: '',
//       survey_no: '',
//       property_type: '',
//       property_type_other: '',
//       type_of_asset: '',
//       hobli: '',
//       village: '',
//       taluk: '',
//       district: '',
//       state: '',
//       pincode: '',
//       geo_location: '',
//     });
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (record) => {
//     const selectedBase = feOptions.find(opt => opt.id === record.asset3_2_baseId) || null;
//     setIsEditMode(true);
//     setSelectedRecord(record);
//     setFormData({
//       asset3_2_base: selectedBase,
//       property_detals: record.property_detals === '-' ? '' : record.property_detals,
//       survey_no: record.survey_no === '-' ? '' : record.survey_no,
//       property_type: ['Agriculture', 'Commercial', 'Flat', 'Other'].includes(record.property_type) ? record.property_type : 'Other',
//       property_type_other: ['Agriculture', 'Commercial', 'Flat', 'Other'].includes(record.property_type) ? '' : record.property_type,
//       type_of_asset: record.type_of_asset === '-' ? '' : record.type_of_asset,
//       hobli: record.hobli === '-' ? '' : record.hobli,
//       village: record.village === '-' ? '' : record.village,
//       taluk: record.taluk === '-' ? '' : record.taluk,
//       district: record.district === '-' ? '' : record.district,
//       state: record.state === '-' ? '' : record.state,
//       pincode: record.pincode === '-' ? '' : record.pincode,
//       geo_location: record.geo_location === '-' ? '' : record.geo_location,
//     });
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (record) => {
//     setDeleteRecord(record);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api.delete(`${API_BASE_URL}/asset-mgmt/asset-property/${deleteRecord.id}/`)
//       .then(() => {
//         setSnackbarMessage('Record deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchData();
//       })
//       .catch(() => {
//         setSnackbarMessage('Failed to delete record.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteRecord(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.asset3_2_base) errors.asset3_2_base = 'Asset3_2 base is required';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFormSubmit = () => {
//     if (!validateForm()) return;
//     setSubmitLoading(true);

//     // Use property_type_other value if property_type is "Other"
//     const finalPropertyType = formData.property_type === 'Other' && formData.property_type_other.trim() !== ''
//       ? formData.property_type_other.trim()
//       : formData.property_type;

//     const payload = {
//       asset3_2_base: formData.asset3_2_base.id,
//       property_detals: formData.property_detals,
//       survey_no: formData.survey_no,
//       property_type: finalPropertyType,
//       type_of_asset: formData.type_of_asset,
//       hobli: formData.hobli,
//       village: formData.village,
//       taluk: formData.taluk,
//       district: formData.district,
//       state: formData.state,
//       pincode: formData.pincode,
//       geo_location: formData.geo_location,
//     };

//     const request = isEditMode
//       ? api.patch(`${API_BASE_URL}/asset-mgmt/asset-property/${selectedRecord.id}/`, payload)
//       : api.post(`${API_BASE_URL}/asset-mgmt/asset-property/`, payload);

//     request.then(() => {
//       setSnackbarMessage(isEditMode ? 'Record updated successfully.' : 'Record added successfully.');
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       fetchData();
//     }).catch(() => {
//       setSnackbarMessage(isEditMode ? 'Failed to update record.' : 'Failed to add record.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     }).finally(() => {
//       setSubmitLoading(false);
//       setOpenFormDialog(false);
//     });
//   };

//   return (
//     <Box sx={{
//       width: '100%', mt: 8, mb: 1,
//       borderRadius: 2,
//       boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//       backgroundColor: '#fff',
//     }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center"
//         bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
//         <Typography variant="h4" component="h1" fontWeight="bold">
//           Admin Asset Property Details
//         </Typography>
//         <Button variant="contained" onClick={handleAdd}>Add Record</Button>
//       </Box>

//       {loading ? <LoadingSpinner size={30} /> : (
//         <TableComponent columns={columns} rows={rows} manageColumnStatus enableSort sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }} />
//       )}

//       {/* Add/Edit Dialog */}
//       <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}
//         fullWidth maxWidth="md">
//         <DialogTitle>{isEditMode ? 'Edit Record' : 'Add Record'}</DialogTitle>
//         <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//           <Autocomplete
//             options={feOptions}
//             getOptionLabel={(option) => option.asset3_2_no || option.notification_no || ''}
//             loading={feLoading}
//             value={formData.asset3_2_base}
//             onChange={(e, newValue) => setFormData({ ...formData, asset3_2_base: newValue })}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Asset 3(2) Base"
//                 error={!!formErrors.asset3_2_base}
//                 helperText={formErrors.asset3_2_base}
//                 margin="dense"
//               />
//             )}
//           />
//           <TextField
//             label="Property Details"
//             value={formData.property_detals}
//             onChange={e => setFormData({ ...formData, property_detals: e.target.value })}
//             margin="dense"
//             fullWidth
//           />
//           <TextField
//             label="Survey No"
//             value={formData.survey_no}
//             onChange={e => setFormData({ ...formData, survey_no: e.target.value })}
//             margin="dense"
//             fullWidth
//           />
//           <TextField
//             select
//             label="Property Type"
//             value={formData.property_type}
//             onChange={e => setFormData({ ...formData, property_type: e.target.value })}
//             margin="dense"
//             fullWidth
//           >
//             <MenuItem value="Agriculture">Agriculture</MenuItem>
//             <MenuItem value="Commercial">Commercial</MenuItem>
//             <MenuItem value="Flat">Flat</MenuItem>
//             <MenuItem value="Other">Other</MenuItem>
//           </TextField>
//           {formData.property_type === 'Other' && (
//             <TextField
//               label="Specify Other Property Type"
//               value={formData.property_type_other}
//               onChange={e =>
//                 setFormData({ ...formData, property_type_other: e.target.value, property_type: e.target.value })}
//               margin="dense"
//               fullWidth
//             />
//           )}
//           <TextField
//             select
//             label="Type of Asset"
//             value={formData.type_of_asset}
//             onChange={e => setFormData({ ...formData, type_of_asset: e.target.value })}
//             margin="dense"
//             fullWidth
//           >
//             <MenuItem value="Movable">Movable</MenuItem>
//             <MenuItem value="Immovable">Immovable</MenuItem>
//           </TextField>
//           <TextField
//             label="Hobli"
//             value={formData.hobli}
//             onChange={e => setFormData({ ...formData, hobli: e.target.value })}
//             margin="dense"
//             fullWidth
//           />
//           <TextField
//             label="Village"
//             value={formData.village}
//             onChange={e => setFormData({ ...formData, village: e.target.value })}
//             margin="dense"
//             fullWidth
//           />
//           <TextField
//             label="Taluk"
//             value={formData.taluk}
//             onChange={e => setFormData({ ...formData, taluk: e.target.value })}
//             margin="dense"
//             fullWidth
//           />
//           <TextField
//             label="District"
//             value={formData.district}
//             onChange={e => setFormData({ ...formData, district: e.target.value })}
//             margin="dense"
//             fullWidth
//           />
//           <TextField
//             label="State"
//             value={formData.state}
//             onChange={e => setFormData({ ...formData, state: e.target.value })}
//             margin="dense"
//             fullWidth
//           />
//           <TextField
//             label="Pincode"
//             value={formData.pincode}
//             onChange={e => setFormData({ ...formData, pincode: e.target.value })}
//             margin="dense"
//             fullWidth
//           />
//           <TextField
//             label="Geo Location"
//             value={formData.geo_location}
//             onChange={e => setFormData({ ...formData, geo_location: e.target.value })}
//             margin="dense"
//             fullWidth
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}>Cancel</Button>
//           <Button variant="contained" onClick={handleFormSubmit} disabled={submitLoading}>
//             {submitLoading ? <LoadingSpinner size={20} /> : (isEditMode ? 'Update' : 'Add')}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Confirmation Dialog */}
//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this record?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitLoading}>Cancel</Button>
//           <Button variant="contained" color="error" onClick={handleDelete} disabled={submitLoading}>Delete</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar */}
//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };




import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  Autocomplete, MenuItem,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import axios from 'axios';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { API_BASE_URL } from '../../../config';
import api from '../../../api/axiosInterceptor';

// Converts DD-MM-YYYY or DD/MM/YYYY to ISO (YYYY-MM-DD)
const convertDisplayDateToISO = (dateStr) => {
  if (!dateStr) return '';
  const parts = dateStr.includes('/') ? dateStr.split('/') : dateStr.split('-');
  if (parts.length !== 3) return '';
  const [day, month, year] = parts;
  return `${year}-${month.padStart(2,'0')}-${day.padStart(2,'0')}`;
};

export const AdminAssetPropertyDetailsComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [feOptions, setFeOptions] = useState([]);
  const [feLoading, setFeLoading] = useState(true);

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [formData, setFormData] = useState({
    asset3_2_base: null,  // object for FE base (Asset3_2)
    property_detals: '',
    survey_no: '',
    property_type: '',      // dropdown value or specified other
    property_type_other: '',// for specifying other property type when "Other" selected
    type_of_asset: '',
    hobli: '',
    village: '',
    taluk: '',
    district: '',
    state: '',
    pincode: '',
    geo_location: '',
  });

  const [formErrors, setFormErrors] = useState({});

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },
    { id: 'name_of_fe', field: 'name_of_fe', headerName: 'Financial Establishment', width: 250 },
    { id: 'name_of_ca', field: 'name_of_ca', headerName: 'Competent Authority', width: 200 },
    { id: 'notification', field: 'notification', headerName: 'Notification', width: 150 },
    { id: 'date', field: 'date', headerName: 'Date', width: 120 },
    { id: 'notification_no', field: 'notification_no', headerName: 'Notification No', width: 150 },
    { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 200 },
    { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 120 },
    { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },
    { id: 'type_of_asset', field: 'type_of_asset', headerName: 'Type of Asset', width: 150 },
    { id: 'hobli', field: 'hobli', headerName: 'Hobli', width: 120 },
    { id: 'village', field: 'village', headerName: 'Village', width: 120 },
    { id: 'taluk', field: 'taluk', headerName: 'Taluk', width: 120 },
    { id: 'district', field: 'district', headerName: 'District', width: 120 },
    { id: 'state', field: 'state', headerName: 'State', width: 120 },
    { id: 'pincode', field: 'pincode', headerName: 'Pincode', width: 100 },
    { id: 'geo_location', field: 'geo_location', headerName: 'Geo Location', width: 200 },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchAsset3_2Options();
    fetchData();
  }, []);

  const fetchAsset3_2Options = () => {
    setFeLoading(true);
    axios.get(`${API_BASE_URL}/asset-mgmt/asset32/`)
      .then(res => setFeOptions(res.data))
      .catch(() => {
        setSnackbarMessage('Failed to load Asset 3(2) base list.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => setFeLoading(false));
  };

  const fetchData = () => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/asset-mgmt/asset-property/`)
      .then(response => {
        const apiData = response.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          name_of_fe: item.asset3_2_base?.fe?.name_of_fe || '-',
          name_of_ca: item.asset3_2_base?.fe?.name_of_ca || '-',
          notification: item.asset3_2_base?.notification || '-',
          date: item.asset3_2_base?.date ? new Date(item.asset3_2_base.date).toLocaleDateString('en-GB').replace(/\//g, '-') : '-',
          notification_no: item.asset3_2_base?.notification_no || '-',
          property_detals: item.property_detals || '-',
          survey_no: item.survey_no || '-',
          property_type: item.property_type || '-',
          type_of_asset: item.type_of_asset || '-',
          hobli: item.hobli || '-',
          village: item.village || '-',
          taluk: item.taluk || '-',
          district: item.district || '-',
          state: item.state || '-',
          pincode: item.pincode || '-',
          geo_location: item.geo_location || '-',
          asset3_2_baseId: item.asset3_2_base?.id || null,
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch(() => {
        setSnackbarMessage('Failed to load Asset Property Details data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAdd = () => {
    setIsEditMode(false);
    setSelectedRecord(null);
    setFormData({
      asset3_2_base: null,
      property_detals: '',
      survey_no: '',
      property_type: '',
      property_type_other: '',
      type_of_asset: '',
      hobli: '',
      village: '',
      taluk: '',
      district: '',
      state: '',
      pincode: '',
      geo_location: '',
    });
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleEdit = (record) => {
    const selectedBase = feOptions.find(opt => opt.id === record.asset3_2_baseId) || null;
    setIsEditMode(true);
    setSelectedRecord(record);
    setFormData({
      asset3_2_base: selectedBase,
      property_detals: record.property_detals === '-' ? '' : record.property_detals,
      survey_no: record.survey_no === '-' ? '' : record.survey_no,
      property_type: ['Agriculture', 'Commercial', 'Flat', 'Other'].includes(record.property_type) ? record.property_type : 'Other',
      property_type_other: ['Agriculture', 'Commercial', 'Flat', 'Other'].includes(record.property_type) ? '' : record.property_type,
      type_of_asset: record.type_of_asset === '-' ? '' : record.type_of_asset,
      hobli: record.hobli === '-' ? '' : record.hobli,
      village: record.village === '-' ? '' : record.village,
      taluk: record.taluk === '-' ? '' : record.taluk,
      district: record.district === '-' ? '' : record.district,
      state: record.state === '-' ? '' : record.state,
      pincode: record.pincode === '-' ? '' : record.pincode,
      geo_location: record.geo_location === '-' ? '' : record.geo_location,
    });
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (record) => {
    setDeleteRecord(record);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api.delete(`/asset-mgmt/asset-property/${deleteRecord.id}/`)
      .then(() => {
        setSnackbarMessage('Record deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchData();
      })
      .catch(() => {
        setSnackbarMessage('Failed to delete record.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteRecord(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.asset3_2_base) errors.asset3_2_base = 'Asset3_2 base is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFormSubmit = () => {
    if (!validateForm()) return;
    setSubmitLoading(true);

    // Use property_type_other value if property_type is "Other"
    const finalPropertyType = formData.property_type === 'Other' && formData.property_type_other.trim() !== ''
      ? formData.property_type_other.trim()
      : formData.property_type;

    const payload = {
      asset3_2_base: formData.asset3_2_base.id,
      property_detals: formData.property_detals,
      survey_no: formData.survey_no,
      property_type: finalPropertyType,
      type_of_asset: formData.type_of_asset,
      hobli: formData.hobli,
      village: formData.village,
      taluk: formData.taluk,
      district: formData.district,
      state: formData.state,
      pincode: formData.pincode,
      geo_location: formData.geo_location,
    };

    const request = isEditMode
      ? api.patch(`/asset-mgmt/asset-property/${selectedRecord.id}/`, payload)
      : api.post(`/asset-mgmt/asset-property/`, payload);

    request.then(() => {
      setSnackbarMessage(isEditMode ? 'Record updated successfully.' : 'Record added successfully.');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchData();
    }).catch(() => {
      setSnackbarMessage(isEditMode ? 'Failed to update record.' : 'Failed to add record.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }).finally(() => {
      setSubmitLoading(false);
      setOpenFormDialog(false);
    });
  };

  return (
    <Box sx={{
      width: '100%', mt: 8, mb: 1,
      borderRadius: 2,
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#fff',
    }}>
      <Box display="flex" justifyContent="space-between" alignItems="center"
        bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
        <Typography variant="h4" component="h1" fontWeight="bold">
          Admin Asset Property Details
        </Typography>
        <Button variant="contained" onClick={handleAdd}>Add Record</Button>
      </Box>

      {loading ? <LoadingSpinner size={30} /> : (
        <TableComponent columns={columns} rows={rows} manageColumnStatus enableSort sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }} />
      )}

      {/* Add/Edit Dialog */}
      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}
        fullWidth maxWidth="md">
        <DialogTitle>{isEditMode ? 'Edit Record' : 'Add Record'}</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Autocomplete
            options={feOptions}
            getOptionLabel={(option) =>
              option.fe?.name_of_fe && option.notification_no
                ? `${option.fe.name_of_fe} - ${option.notification_no}`
                : option.asset3_2_no || option.notification_no || ''
            }
            loading={feLoading}
            value={formData.asset3_2_base}
            onChange={(e, newValue) => setFormData({ ...formData, asset3_2_base: newValue })}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Asset 3(2) Base"
                error={!!formErrors.asset3_2_base}
                helperText={formErrors.asset3_2_base}
                margin="dense"
              />
            )}
          />
          <TextField
            label="Property Details"
            value={formData.property_detals}
            onChange={e => setFormData({ ...formData, property_detals: e.target.value })}
            margin="dense"
            fullWidth
          />
          <TextField
            label="Survey No"
            value={formData.survey_no}
            onChange={e => setFormData({ ...formData, survey_no: e.target.value })}
            margin="dense"
            fullWidth
          />
          <TextField
            select
            label="Property Type"
            value={formData.property_type}
            onChange={e => setFormData({ ...formData, property_type: e.target.value })}
            margin="dense"
            fullWidth
          >
            <MenuItem value="Agriculture">Agriculture</MenuItem>
            <MenuItem value="Commercial">Commercial</MenuItem>
            <MenuItem value="Flat">Flat</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
          {formData.property_type === 'Other' && (
            <TextField
              label="Specify Other Property Type"
              value={formData.property_type_other}
              onChange={e =>
                setFormData({ ...formData, property_type_other: e.target.value, property_type: e.target.value })}
              margin="dense"
              fullWidth
            />
          )}
          <TextField
            select
            label="Type of Asset"
            value={formData.type_of_asset}
            onChange={e => setFormData({ ...formData, type_of_asset: e.target.value })}
            margin="dense"
            fullWidth
          >
            <MenuItem value="Movable">Movable</MenuItem>
            <MenuItem value="Immovable">Immovable</MenuItem>
          </TextField>
          <TextField
            label="Hobli"
            value={formData.hobli}
            onChange={e => setFormData({ ...formData, hobli: e.target.value })}
            margin="dense"
            fullWidth
          />
          <TextField
            label="Village"
            value={formData.village}
            onChange={e => setFormData({ ...formData, village: e.target.value })}
            margin="dense"
            fullWidth
          />
          <TextField
            label="Taluk"
            value={formData.taluk}
            onChange={e => setFormData({ ...formData, taluk: e.target.value })}
            margin="dense"
            fullWidth
          />
          <TextField
            label="District"
            value={formData.district}
            onChange={e => setFormData({ ...formData, district: e.target.value })}
            margin="dense"
            fullWidth
          />
          <TextField
            label="State"
            value={formData.state}
            onChange={e => setFormData({ ...formData, state: e.target.value })}
            margin="dense"
            fullWidth
          />
          <TextField
            label="Pincode"
            value={formData.pincode}
            onChange={e => setFormData({ ...formData, pincode: e.target.value })}
            margin="dense"
            fullWidth
          />
          <TextField
            label="Geo Location"
            value={formData.geo_location}
            onChange={e => setFormData({ ...formData, geo_location: e.target.value })}
            margin="dense"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}>Cancel</Button>
          <Button variant="contained" onClick={handleFormSubmit} disabled={submitLoading}>
            {submitLoading ? <LoadingSpinner size={20} /> : (isEditMode ? 'Update' : 'Add')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this record?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitLoading}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleDelete} disabled={submitLoading}>Delete</Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
